<template>
  <section>
    <!--工具条-->
    <el-form class="form_cls" :inline="true" :model="filters" @submit.native.prevent>
      <el-form-item label="">
        <el-input v-model="filters.originalPositionCode" placeholder="原始岗位号" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="filters.originalName" placeholder="原员工姓名" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="filters.replacementPositionCode" placeholder="代岗岗位号" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="filters.replacementName" placeholder="代岗员工姓名" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="filters.status" placeholder="状态" clearable style="width: 120px">
          <el-option label="全部" value="all"></el-option>
          <el-option label="生效中" value="active"></el-option>
          <el-option label="未生效" value="pending"></el-option>
          <el-option label="已过期" value="expired"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <div class="table_top_div">
      <div>
        <el-table
          border
          :max-height="tableHeight"
          :data="tableData"
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA' }"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          v-loading="listLoading"
        >
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column sortable prop="originalPositionCode" label="原始岗位号" ></el-table-column>
          <el-table-column sortable prop="originalName" label="原员工姓名"  ></el-table-column>
          <el-table-column sortable prop="replacementPositionCode" label="代岗岗位号"  ></el-table-column>
          <el-table-column sortable prop="replacementName" label="代岗员工姓名"  ></el-table-column>
          <el-table-column sortable prop="startTime" label="开始时间" >
            <template slot-scope="scope">
              {{ scope.row.startTime ? formatDate(scope.row.startTime) : '立即生效' }}
            </template>
          </el-table-column>
          <el-table-column sortable prop="endTime" label="结束时间" >
            <template slot-scope="scope">
              {{ scope.row.endTime ? formatDate(scope.row.endTime) : '永久有效' }}
            </template>
          </el-table-column>
          <el-table-column sortable prop="status" label="状态"  >
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row.status)" size="small">{{ scope.row.status }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column sortable prop="createTime" label="创建时间"  >
            <template slot-scope="scope">
              {{ formatDate(scope.row.createTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" fixed="right">
            <template slot-scope="scope">
              <el-link type="primary" @click="handleEdit(scope.row)" :underline="false">
                <i class="el-icon-edit"></i>编辑
              </el-link>
              <el-divider direction="vertical"></el-divider>
              <el-link type="danger" @click="handleDelete(scope.row)" :underline="false">
                <i class="el-icon-delete"></i>删除
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="toolbar_div">
        <el-col :span="24" class="toolbar">
          <el-pagination
            :current-page="page"
            :background="true"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :total="total"
            style="float: right"
          ></el-pagination>
        </el-col>
      </div>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose">
      <el-form :model="formData" :rules="formRules" ref="formRef" label-width="140px" label-position="left">
        <el-form-item label="原始岗位号" prop="originalPositionCode">
          <el-input v-model="formData.originalPositionCode" placeholder="请输入原始岗位号"></el-input>
        </el-form-item>
        <el-form-item label="原员工姓名">
          <el-input v-model="formData.originalName" placeholder="请输入原员工姓名（可选）"></el-input>
        </el-form-item>
        <el-form-item label="代岗岗位号" prop="replacementPositionCode">
          <el-input v-model="formData.replacementPositionCode" placeholder="请输入代代岗岗位号"></el-input>
        </el-form-item>
        <el-form-item label="代岗员工姓名">
          <el-input v-model="formData.replacementName" placeholder="请输入代岗员工姓名（可选）"></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker
            v-model="formData.startTime"
            type="datetime"
            placeholder="选择开始时间（不选则立即生效）"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker
            v-model="formData.endTime"
            type="datetime"
            placeholder="选择结束时间（不选则永久有效）"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from '../../../util/date'
import {
  getFlacsDelegateRelationList,
  createFlacsDelegateRelation,
  editFlacsDelegateRelation,
  deleteFlacsDelegateRelation
} from '@/api/api'

export default {
  name: 'FlacsDelegateRelation',
  data() {
    return {
      // 筛选条件
      filters: {
        originalPositionCode: '',
        originalName: '',
        replacementPositionCode: '',
        replacementName: '',
        status: 'all'
      },
      // 表格数据
      tableData: [],
      listLoading: false,
      tableHeight: window.innerHeight - 180,
      // 分页
      page: 1,
      pageSize: 20,
      total: 0,
      // 对话框
      dialogVisible: false,
      dialogTitle: '新增代岗配置',
      isEdit: false,
      submitLoading: false,
      // 表单数据
      formData: {
        id: null,
        originalPositionCode: '',
        originalName: '',
        replacementPositionCode: '',
        replacementName: '',
        startTime: null,
        endTime: null
      },
      // 表单验证规则
      formRules: {
        originalPositionCode: [{ required: true, message: '请输入被代岗岗位号', trigger: 'blur' }],
        replacementPositionCode: [{ required: true, message: '请输入代岗人岗位号', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getHeight()
    })
    this.loadData()
    window.addEventListener('resize', this.getHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    // 计算表格高度
    getHeight() {
      this.tableHeight = window.innerHeight - 180
    },
    // 加载数据
    async loadData() {
      this.listLoading = true
      try {
        const params = {
          ...this.filters,
          page: this.page,
          pageSize: this.pageSize
        }
        const res = await getFlacsDelegateRelationList(params)
        
        // 根据实际返回结构处理数据
        // 后端通过 Furion 返回，数据在 res.data 中
        if (res && res.data) {
          // res.data 就是 PageModel 对象，包含 data（数据数组）和 dataCount
          this.tableData = res.data.data || []
          this.total = res.data.dataCount || 0
        }
      } catch (error) {
        this.$message.error('加载数据失败: ' + error.message)
      } finally {
        this.listLoading = false
      }
    },
    // 查询
    handleSearch() {
      this.page = 1
      this.loadData()
    },
    // 重置
    handleReset() {
      this.filters = {
        originalPositionCode: '',
        originalName: '',
        replacementPositionCode: '',
        replacementName: '',
        status: 'all'
      }
      this.page = 1
      this.loadData()
    },
    // 新增
    handleAdd() {
      this.dialogTitle = '新增代岗配置'
      this.isEdit = false
      this.dialogVisible = true
    },
    // 编辑
    handleEdit(row) {
      this.dialogTitle = '编辑代岗配置'
      this.isEdit = true
      this.formData = {
        id: row.id,
        originalPositionCode: row.originalPositionCode,
        originalName: row.originalName,
        replacementPositionCode: row.replacementPositionCode,
        replacementName: row.replacementName,
        startTime: row.startTime,
        endTime: row.endTime
      }
      this.dialogVisible = true
    },
    // 删除
    handleDelete(row) {
      if (!row.id) {
        this.$message.error('配置ID无效')
        return
      }
      this.$confirm('确认删除该代岗配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          try {
            const result = await deleteFlacsDelegateRelation(row.id)
            // axios 返回的数据在 result.data 中
            if (result && result.data && result.data.code === 200) {
              this.$message.success(result.data.msg || '删除成功')
              this.loadData()
            } else {
              this.$message.error((result && result.data && result.data.msg) || '删除失败')
            }
          } catch (error) {
            const errorMsg = (error.response && error.response.data && error.response.data.msg) || error.message
            this.$message.error('删除失败: ' + errorMsg)
          }
        })
        .catch(() => {})
    },
    // 提交表单
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) {
          return
        }
        this.submitLoading = true
        try {
          let result
          if (this.isEdit) {
            result = await editFlacsDelegateRelation(this.formData)
          } else {
            result = await createFlacsDelegateRelation(this.formData)
          }
          // axios 返回的数据在 result.data 中
          if (result && result.data && result.data.code === 200) {
            this.$message.success(result.data.msg || (this.isEdit ? '编辑成功' : '创建成功'))
            this.dialogVisible = false
            this.loadData()
          } else {
            // 如果返回的 code 不是 200，显示错误信息
            this.$message.error((result && result.data && result.data.msg) || (this.isEdit ? '编辑失败' : '创建失败'))
          }
        } catch (error) {
          const errorMsg = (error.response && error.response.data && error.response.data.msg) || error.message
          this.$message.error((this.isEdit ? '编辑失败: ' : '创建失败: ') + errorMsg)
        } finally {
          this.submitLoading = false
        }
      })
    },
    // 对话框关闭
    handleDialogClose() {
      this.$refs.formRef.resetFields()
      this.formData = {
        id: null,
        originalPositionCode: '',
        originalName: '',
        replacementPositionCode: '',
        replacementName: '',
        startTime: null,
        endTime: null
      }
    },
    // 当前页变化
    handleCurrentChange(val) {
      this.page = val
      this.loadData()
    },
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    // 获取状态标签类型
    getStatusType(status) {
      const typeMap = {
        生效中: 'success',
        未生效: 'warning',
        已过期: 'info'
      }
      return typeMap[status] || ''
    }
  }
}
</script>

<style scoped>
</style>
